export default __webpack_public_path__ + "static/media/tBTC-bridge-no-history-light.321ddbad.svg";